import axiosInstance from './axiosInstance';

/**
 * Manager Service
 * Handles all manager related API calls
 */

const managerService = {
  /**
   * Create a new manager for an organization
   * @param {Object} managerData
   * @returns {Promise}
   */
  createManager: async (managerData) => {
    try {
      const response = await axiosInstance.post(
        '/admin/managers',
        managerData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get all managers
   * @param {Object} params - query parameters
   * @returns {Promise}
   */
  getAllManagers: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/admin/managers', {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get managers for a specific organization
   * @param {number} organizationId
   * @returns {Promise}
   */
  getManagersByOrganization: async (organizationId) => {
    try {
      const response = await axiosInstance.get('/admin/managers', {
        params: { organization_id: organizationId },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get manager by ID
   * @param {number} id
   * @returns {Promise}
   */
  getManagerById: async (id) => {
    try {
      const response = await axiosInstance.get(`/admin/managers/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Update manager
   * @param {number} id
   * @param {Object} updateData
   * @returns {Promise}
   */
  updateManager: async (id, updateData) => {
    try {
      const response = await axiosInstance.put(
        `/admin/managers/${id}`,
        updateData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Delete manager
   * @param {number} id
   * @returns {Promise}
   */
  deleteManager: async (id) => {
    try {
      const response = await axiosInstance.delete(`/admin/managers/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Approve manager
   * @param {number} id
   * @returns {Promise}
   */
  approveManager: async (id) => {
    try {
      const response = await axiosInstance.patch(
        `/admin/managers/${id}/approve`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Deactivate manager
   * @param {number} id
   * @returns {Promise}
   */
  deactivateManager: async (id) => {
    try {
      const response = await axiosInstance.patch(
        `/admin/managers/${id}/deactivate`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default managerService;
